module.exports = __webpack_public_path__ + "img/red_067.84f5d472.png";